import React, { useEffect, useState, useRef } from 'react'
import File from '../../assets/img/file@2x.png'
import { FileInputContainer } from '../../Containers/PasserCommande/PasserCommande.styles'
import { uploadFilesCommande, uploadFile } from '../../api/upload'
import { useTranslation } from 'react-i18next'

function UploadSingleFileCommande({
	name,
	disabled,
	onFile,
	accept = '',
	maxFileSize = 10 * 1024 * 1024,
	commandeId,
	missionId,
	key,
}) {
	const [file, setFile] = useState(null)
	const inputRef = useRef(null)

	useEffect(() => {
		async function uploadSingleFile() {
			let res = null
			if (commandeId || missionId || (commandeId && missionId)) {
				res = await uploadFilesCommande(file, commandeId, missionId)
			} else {
				res = await uploadFile(file)
			}
			onFile(res.data)
		}
		if (file) {
			uploadSingleFile()
		}
	}, [file])

	const handleFileChange = (e) => {
		// If disabled, don't process file changes
		if (disabled) return

		const selectedFile = e.target.files[0]
		// First check if a file was selected
		if (!selectedFile) return
		// Check file size
		if (selectedFile.size > maxFileSize) {
			alert(
				`Le fichier est trop volumineux. La taille maximale autorisée est de 10MB.`
			)
			return
		}
		// Check file type if accept parameter is provided
		if (accept) {
			const fileType = selectedFile.type?.split('/')[1]
			if (!accept.includes(fileType)) {
				alert(
					`Désolé, le fichier que vous avez essayé de télécharger n'est pas pris en charge. Veuillez choisir un format de fichier valide.`
				)
				return
			}
		}
		// If all checks pass, set the file
		setFile(selectedFile)

		if (inputRef.current) {
			inputRef.current.value = ''
		}
	}
	const {t} = useTranslation()

	return (
		<div
			style={{
				width: '100%',
				display: 'flex',
				flex: 1,
				borderRadius: '0.5rem',
				background: disabled ? '#f0f0f0' : 'white', // Gray background when disabled
				alignItems: 'center',
				justifyContent: 'space-between',
				marginBottom: '1rem',
				position: 'relative',
				opacity: disabled ? 0.7 : 1, // Reduce opacity when disabled
			}}
		>
			{file && (
				<img
					src={File}
					style={{
						height: 20,
						marginLeft: '1rem',
						marginRight: '1rem',
					}}
					alt=''
				/>
			)}
			<span
				style={{
					width: '100%',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap',
				}}
			>
				{file && file.name}
			</span>
			<FileInputContainer>
				<input
					ref={inputRef}
					type='file'
					id={name}
					name={name}
					className='file'
					accept={accept}
					onChange={handleFileChange}
					disabled={disabled} // Disable the input element
					style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
				/>
				<label
					htmlFor={name}
					style={{
						cursor: disabled ? 'not-allowed' : 'pointer',
						backgroundColor: disabled ? '#cccccc' : '', // Gray button when disabled
					}}
				>
					{t("upload")}
				</label>
			</FileInputContainer>
		</div>
	)
}

export default UploadSingleFileCommande
